module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/client-detail/client-detail.component.scss
// module id = ./src/app/clients/client-detail/client-detail.component.scss
// module chunks = main